const appName = {
  dev: 'Orbital-dev',
  production: 'Orbital',
};

const sideBarItems = [
  {
    name: 'Ganymede',
    displayName: 'Time Machine',
    iconName: 'comparison',
    items: ['Manage', 'Explorer', 'Prices'],
  },
  {
    name: 'Io',
    displayName: 'Utilities',
    iconName: 'cog',
    items: ['SK Utility'],
  },
];

const demoMode = false;

const buildNumberReset = process.env.REACT_APP_STAGE === 'production' ? 65 : 207;

export { appName, sideBarItems, demoMode, buildNumberReset };
